import { forwardRef, TextareaHTMLAttributes } from 'react';
import styles from './textarea.module.sass';
import { int } from "@/lib/format";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  /** Shows a "used / limit" counter, marked once the limit is passed, so the
   *  writer sees the endpoint's cap while typing rather than as a 422 on save. */
  maxLength?: number;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helperText, maxLength, value, ...rest }, ref) => {
    const used = typeof value === 'string' ? value.length : 0;
    const over = maxLength != null && used > maxLength;

    return (
      <div className={styles.formGroup}>
        {label && <label className={styles.formLabel}>{label}</label>}
        <textarea
          ref={ref}
          className={`${styles.formTextarea} ${error || over ? styles.error : ''}`}
          value={value}
          {...rest}
        />
        {(error || helperText || maxLength != null) && (
          <div className={styles.footer}>
            {error && <span className={styles.formError}>{error}</span>}
            {helperText && !error && <span className={styles.formHint}>{helperText}</span>}
            {maxLength != null && (
              <span className={`${styles.counter} ${over ? styles.counterOver : ''}`}>
                {int(used)} / {int(maxLength)}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
